import { MainMenuItemsType } from "./types";

import menuRentIcon from "@assets/icons/menuRent.svg";
import menuServicesIcon from "@assets/icons/menuServices.svg";
import menuPadelIcon from "@assets/icons/menuPadel.svg";
import menuAboutIcon from "@assets/icons/menuAbout.svg";

export const mainMenuItems: MainMenuItemsType = [
  { id: "rentCourts", name: "Аренда кортов", href: "/", subMenu: false, icon: menuRentIcon },
  { id: "services", name: "Сервис", href: "/services", subMenu: "SubMenu", icon: menuServicesIcon },
  { id: "padel", name: "Padel", href: "/padel", subMenu: "SubMenu", icon: menuPadelIcon },
  { id: "school", name: "Школа тенниса", href: "/services/tennis-school", subMenu: false },
  { id: "about", name: "О клубе", href: "/about", subMenu: "SubMenu", icon: menuAboutIcon },
  { id: "contacts", name: "Контакты", href: "/contacts", subMenu: false },
];